import React, { useEffect, useState } from 'react';
import {fire} from "../firebase/config";
import { Link } from "react-router-dom";

import { Container, Row, Col } from "react-bootstrap";
import Message from '../Components/Message';

const MessagePage = (props) => {
  const [recipient, setRecipient] = useState();
  const [message, setMessage] = useState([]);
  const [messages, setMessages] = useState([]);
  const [forUpdate, setForUpdate] = useState(0);
  const [contacts, setContacts] = useState([]);
const [text, setText] = useState();

  useEffect(() => {
    console.log("1");
   receiveInfo()
   receiveInfo()
    
    return () => {
      
    };
  }, []);

 const receiveInfo=()=>{
   
  if(props.match.params.id && fire.auth().currentUser){
    console.log("2");
    fire
    .database()
    .ref("/users/" + props.match.params.id)
    .once("value")
    .then((snapshot) => {
      setRecipient(snapshot.val());
     
    });
    fire
    .database()
    .ref("/users/" + fire.auth().currentUser.uid+"/message")
    .once("value")
    .then((snapshot) => {
      let z=[]
      let x=Object.keys(snapshot.val())
      x.map(elem=>{
        fire
        .database()
        .ref("/users/" + elem)
        .once("value")
        .then((snapshot) => {
          let k=snapshot.val()
          z.push([k.name,elem])

      })
      setContacts(z );
      console.log(z);
      
      
     
    });
  })
    fire
    .database()
    .ref("/users/" + fire.auth().currentUser.uid+"/message/"+ props.match.params.id)
    .once("value")
    .then((snapshot) => {
      let x=snapshot.val()
      setMessages(Object.values(x));
      
      
     
    });
    
    return
  }
  
    if(!fire.auth().currentUser){
     setTimeout(() => {
       receiveInfo()
     }, 1000);
    }
   
 }

  const handleChange=(e)=>{
    setText(e.target.value)
  }
const sendMsg=()=>{
  
  let msg={

    text:text,
    type:"send"
  }
  fire
  .database()
  .ref("/users/" + fire.auth().currentUser.uid+"/message/"+props.match.params.id)
  .push(msg)
  .then(() => {
receiveInfo()

  })
  let receiveMsg={
    text:text,
    type:"receive"
  }
  fire
  .database()
  .ref("/users/" + props.match.params.id+"/message/"+fire.auth().currentUser.uid)
  .push(receiveMsg)
  .then(() => {
  setForUpdate(Math.random()*10)
  })
}
    return (
        
            <section class="admin">
      <Container>
      <Row>
       
          <div class="col-lg-9 m-auto">
            <form action="#" class="admin-form">
              <div class="admin-form__items d-flex">
                <div class="admin-form__search">
                  <input type="text" placeholder="Поиск" class="admin-search" />
                  <div class="admin-form__administration">
                      <div className="contactsBlock">
                        {contacts.map((item,i)=>{
                          return <Link to={item[1]}>{item[0]}</Link>
                        })}
                      </div>
                    <div class="admin-form-administration__info d-flex">
                      <div class="administration-info__logo">
                        <img src={props.match.params.id ? "/img/seller.png":"/img/logo.png"} alt="logo" />
                      </div>
                      <div class="administration-info__logo__text">
                        {recipient ? recipient.name:"Администрация"}
                    
                      </div>
                    </div>
                    <div>

                    </div>
                  </div>
                </div>
                <div class="admin-box">
                  <div class="admin-form__msg">
                    <div class="admin-form-msg__admin d-flex">
                      <div class="administration-info__logo">
                        <img src={props.match.params.id ? "/img/seller.png":"/img/logo.png"} alt="logo" />
                      </div>
                      <div class="administration-info__logo__text">
                      {recipient ? recipient.name:"Администрация"}
                      </div>
                    </div>
                    <div className="admin-form-msg-row">
{messages.length>0 ? <Message text={messages} />:null}
                    </div>
                  </div>
                  <div class="admin-form-msg__send d-flex">
                    <div class="admin-form-msg-send__screpka">
                      <a href="#"><img src="/img/screpka.svg" alt="img" /></a>
                    </div>
                    <div class="admin-form-msg-send__text">
                      <input
                        type="text"
                        placeholder="Сообщение"
                        class="afmst"
                        onChange={handleChange}
                      />
                    </div>
                    <div class="admin-form-msg-send__img" onClick={sendMsg}>
                      <a href="#"
                        ><img src="/img/strictright.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          </Row>
        </Container>
    </section>
       
    );
}

export default MessagePage;
